import React, { useEffect, useState } from "react";
import controllers from "../../controllers/projects";
import LoaderData from "../../component/LoaderData/LoaderData";
import { useTranslation } from "react-i18next";

const Project = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const getProjectsList = () => {
      setLoading(true);
      return controllers
        .getProjectsList({
          limit: 2,
          page: 0,
        })
        .then((response) => {
          setData(response);
          setTimeout(() => {
            setLoading(false);
          }, 400);
        })
        .catch((error) => {
          setLoading(false);
          window.location.href = "/500";
        });
    };
    getProjectsList();
  }, []);

  return (
    <>
      {(!data && !loading) ||
        (data.length === 0 && !loading && (
          <h4
            style={{
              textAlign: "center",
              margin: "50px auto",
              marginLeft: '15px',
              color: "#c4c4c4",
              width: '100%'
            }}
          >
            {isEnglish ? "No Projects found !" : "Aucune Projets trouvée !"}
          </h4>
        ))}
      {loading && <LoaderData />}
      <div className="rn-project-area line-separator">
        <div className="container">
          <div className="row">
            {data &&
              data.length > 0 &&
              data.map((value, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="item-project-static">
                    <div>
                      <div className="project-static">
                        <div className="thumbnail-inner">
                          <div className="thumbnail">
                            <a>
                              <img
                                src={`${process.env.REACT_APP_DOMAIN}/api/projectsimages/${value.project_id}/${value.image}`}
                                alt="Projects Images"
                                style={{
                                  height: "328px",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </a>
                          </div>
                        </div>
                        <div className="content">
                          <div className="inner">
                            <p>{value.duration}</p>
                            <h4>
                              <a
                                href={
                                  "/projects/" +
                                  value.title.fr.split(" ").join("-") +
                                  "/?id=" +
                                  value.id
                                }
                              >
                                {isEnglish
                                  ? value.title.en
                                      .split(" ")
                                      .splice(0, 30)
                                      .join(" ") + "..."
                                  : value.title.fr
                                      .split(" ")
                                      .splice(0, 30)
                                      .join(" ") + "..."}
                              </a>
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Project;
